import React, { Fragment, useEffect, useState } from "react";
import './AccountMobView.css';
import './Account.css';
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import UserProfile from "./UserProfile";
import { accountPageData } from "./accountPageData";
// import MetaData from '../../layout/MetaData';
import { useSelector } from "react-redux";
import { Link, NavLink, Outlet } from "react-router-dom";
import PaymentsIcon from '@mui/icons-material/Payments';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import PowerSettingsNewOutlined from "@mui/icons-material/PowerSettingsNewOutlined";
import AllAddresses from "../addressPages/AllAddresses";
import Loader from "../../layout/Loader/Loader";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ProfileDetails from "../Profile/ProfileDetails";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import InventoryIcon from '@mui/icons-material/Inventory';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import GradientOrderIcon from "../../layout/Gradient icons/OrderIcon";
import GradientFavouritesIcon from "../../layout/Gradient icons/FavoritesIcon";
import GradientAddressIcon from "../../layout/Gradient icons/AddressIcon";
import GradientRewardsIcon from "../../layout/Gradient icons/RewardsIcon";
import GradientNotificationIcon from "../../layout/Gradient icons/NotificationIcon";
import GradientFaqIcon from "../../layout/Gradient icons/FAQIcon";
import GradientPrivacyIcon from "../../layout/Gradient icons/PrivacyIcon";
import { isLoggedIn } from "../../../authUtils";



function AccountMobView({slModalOpen}) {
  const { user, loading, isAuthenticated } = useSelector((state) => state.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Assuming 768px as the mobile breakpoint

  console.log(user)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

const loggedIn = isLoggedIn();

  // const [click, setClick] = useState(false);
  // const [toggleState, setToggleState] = useState(1);
  // const toggleTab = (index) => {
  //   setToggleState(index);
  // }

  // const handleClick = () => setClick(!click);
  const ordersRoute = {
    label: 'Your Orders',
    path: '/account/your-orders',
    icon: <GradientOrderIcon />,
  };

  const userRoute = {
    label: 'Your Profile',
    path: '/account/your-profile',
  };

  const routes = [
    { label: 'Wishlist', path: '/account/wishlists', icon: <GradientFavouritesIcon/> },
    { label: 'Your Address', path: '/account/addresses', icon: <GradientAddressIcon/> },
    { label: 'Your Notifications', path: '/notifications', icon: <GradientNotificationIcon/> },
    { label: 'Rewards', path: '/coupons', icon: <GradientRewardsIcon/> },
  ];
  
  const handleNavigation = (path) => {
    if (loggedIn) {
      // If the user is logged in, navigate to the specified route
      window.location.href = path;
    } else {
      // If the user is not logged in, open the modal
      slModalOpen();
    }
  };

  return (
    <Fragment>
        <div className="account_main_mob">
          <div className="account_inr_mob">
            <div className="account_top_container">
              <div className="account_profile_wrap" style={{ cursor: 'pointer' }}
                  onClick={() => handleNavigation(userRoute.path)}>
                <span className="user_profile_picture"></span>
                {loggedIn ? 'kamal Biswal' : 'Hello User'}
              </div>
              <div className="acc_nav_btns_group">
                
                <div className="nav_btns_each">
                  <span className="nav_icon">{ordersRoute.icon}</span>
                  <span className="add_border_btm no_brdr_btm"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleNavigation(ordersRoute.path)}>{ordersRoute.label}</span>
               </div> 
              </div>
              <div className="acc_nav_btns_group">
              {routes.map((route, index) => (
                <div className="nav_btns_each">
                  <span className="nav_icon">{route.icon}</span>
                  <span
                  className="add_border_btm"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleNavigation(route.path)}
                >{route.label}</span>
                 
                </div>
              ))}
            </div>
              {/* <div className="account_opt_mob"> */}
                  {/* <h4>Account Options</h4> */}
                  {/* <NavLink to='/account/your-profile'>Edit Profile</NavLink> */}
                  {/* <NavLink to='/account/addresses'>Your reviews</NavLink>
              </div> */}
              <div className="acc_nav_btns_group">
                  <NavLink to='#'><span className="nav_icon"><GradientFaqIcon/></span><span className="add_border_btm">FAQs</span></NavLink>
                  <NavLink to='#'><span className="nav_icon"><GradientPrivacyIcon/></span><span className="add_border_btm no_brdr_btm">Privacy & security</span></NavLink>
                  {/* <NavLink to='#'>FAQs</NavLink> */}
              </div>
              <div className="account_logout_mob">
                  <div className="account_logout_inr_mob">Logout</div>
              </div>
            </div>
          </div>
        </div>
    </Fragment>
  );
}

export default AccountMobView;